interface ISwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  disabled?: boolean;
}

export const Switch = ({
  checked,
  onChange,
  id = 'switch',
  disabled = false,
}: ISwitchProps) => {
  return (
    <label
      htmlFor={id}
      className={`inline-flex items-center ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      }`}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={() => onChange(!checked)}
        disabled={disabled}
        className="sr-only peer"
      />

      <div className="relative h-5 w-9">
        {/* Track */}
        <div
          className={`
            h-5 w-9 rounded-full transition-colors duration-300
            ${checked ? 'bg-brand-default' : 'bg-neutral-200'}
          `}
        />

        {/* Thumb */}
        <div
          className={`
            absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white
            transition-transform duration-300
            ${checked ? 'translate-x-4' : 'translate-x-0'}
          `}
        />
      </div>
    </label>
  );
};
